module.exports = __webpack_public_path__ + "img/userScale1.853a919a.png";